import { useId } from 'react'

import { useFocusTrap } from '../hooks/useFocusTrap'

type ConfirmDialogProps = {
  open: boolean
  title: string
  message: string
  confirmLabel?: string
  cancelLabel?: string
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = 'Подтвердить',
  cancelLabel = 'Отмена',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) => {
  const titleId = useId()
  const messageId = useId()
  const dialogRef = useFocusTrap<HTMLDivElement>(open, { onClose: onCancel })

  if (!open) return null

  return (
    <div className="market-paywall-overlay" role="presentation" onClick={onCancel}>
      <div
        ref={dialogRef}
        className="market-paywall-modal market-confirm-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={titleId}
        aria-describedby={messageId}
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id={titleId} className="market-paywall-modal__title">
          {title}
        </h2>
        <p id={messageId} className="market-confirm-dialog__message">
          {message}
        </p>
        <div className="market-paywall-modal__actions">
          <button type="button" className="echat-btn echat-btn--ghost echat-btn--sm" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button type="button" className="echat-btn echat-btn--danger-soft echat-btn--sm" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
